import * as React from 'react';
import { forwardRef } from 'react';
const Search = (props, ref) => {
    return (React.createElement("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.976 12.331a6.562 6.562 0 1 1 1.355-1.355l2.888 2.888a.958.958 0 0 1-1.355 1.355l-2.888-2.888Zm1.243-5.269a5.156 5.156 0 1 1-10.313 0 5.156 5.156 0 0 1 10.313 0Z", fill: "var(--mollie-ui-icon-fill, currentColor)" })));
};
const ForwardRef = forwardRef(Search);
export default ForwardRef;
ForwardRef.displayName = 'Search';
//# sourceMappingURL=Search.js.map